class Teacher {
	id = null;
	first_name = '';
	last_name = '';
	title = '';
	oib = '';
	address = '';
	postal_code = '';
	city = '';
	country = 1;
	phone = '';
	email = '';
	bank = '';
	iban = '';
	t1 = null;
	t2 = null;
	t3 = null;
	t4 = null;
	remark = '';
	approvals = [];
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Teacher;
